export const columns = [
	{ id: 'name', label: 'Nombre', width: '350px' },
	{
		id: 'companyBadgeNumber',
		label: 'Núm. de empleado',
		width: '200px',
	},
	{ id: 'branchOffice', label: 'Sucursal', width: '250px' },
	{ id: 'status', label: 'Status', width: '120px' },
	{ id: 'nationalIdentity', label: 'CURP', width: '220px' },
	{ id: 'sector', label: 'Sector', width: '200px' },
	{ id: 'position', label: 'Posición', width: '200px' },
	{ id: 'shift', label: 'Turno', width: '200px' },
	{ id: 'hiringDate', label: 'Fecha de ingreso', width: '150px' },
	{
		id: 'birthDate',
		label: 'Fecha de nacimiento',
		width: '150px',
	},
	{ id: 'gender', label: 'Genero', width: '150px' },
	{ id: 'schooling', label: 'Escolaridad', width: '200px' },
	{ id: 'phone', label: 'Teléfono', width: '150px' },
	{
		id: 'alternativeEmail',
		label: 'Alternative Email',
		width: '350px',
	},
	{ id: 'insuranceName', label: 'Membresía', width: '200px' },
	{
		id: 'physicalCheckupAppointmentStatus',
		label: 'Estatus Valoración Médica',
		width: '200px',
	},
	{
		id: 'labCheckupAppointmentStatus',
		label: 'Estatus Exámenes de Laboratorio',
		width: '200px',
	},
	{
		id: 'dismissalDate',
		label: 'Fecha de baja',
		width: '150px',
	},
	{ id: 'id', label: 'ID Welbe', width: '400px' },
];
